import { qs, qsa } from '../utils'

import scroll from '../animations/scroll/locomotiveScroll'

import gsap, { Power4 } from 'gsap'

class ArchiveFaq {
  constructor() {
    this.namespace = 'archive-faq'
  }

  afterEnter({ next }) {
    this.container = next.container
    this.toggles = qsa('[data-toggle]', this.container)
    this.tabs = qsa('[data-tab]', this.container)

    this.accordionToggles = qsa('[data-accordion-toggle]', this.container)
    this.accordionContents = qsa('[data-accordion-content]', this.container)

    this.active = this.toggles[0].getAttribute('data-toggle')
    this.itemW = this.toggles[0].parentNode.getBoundingClientRect().width
    this.bindedFunction = null
    this.accordionFunction = null

    this.setActiveTab()
    this.addListeners()
  }

  beforeLeave(data) {
  }

  addListeners() {
    this.bindedFunction = this.handleClick.bind(this)

    this.toggles.forEach(toggle => {
      toggle.addEventListener('click', this.bindedFunction)
    })

    this.accordionFunction = this.handleAccordion.bind(this)
    this.accordionToggles.forEach(accordionToggle => {
      accordionToggle.addEventListener('click', this.accordionFunction)
    })
  }

  removeListeners() {
    this.toggles.forEach(toggle => {
      toggle.removeEventListener('click', this.bindedFunction)
    })
  }

  setActiveTab() {
    const index = this.toggles.findIndex(toggle => toggle.getAttribute('data-toggle') === this.active)
    document.documentElement.style.setProperty('--tab-indicator', `${this.itemW * index}px`)

    this.toggles.forEach(toggle => {
      toggle.classList.remove('active')
    })

    const activeToggle = this.toggles.find(toggle => toggle.getAttribute('data-toggle') === this.active)
    activeToggle.classList.add('active')

    this.tabs.forEach(tab => {
      tab.classList.remove('active')
    })

    const activeTab = this.tabs.find(tab => tab.getAttribute('data-tab') === this.active)
    activeTab.classList.add('active')
  }

  handleClick(e) {
    const accordions = qsa('[data-accordion]', this.container)
    accordions.forEach(accordion => {
      accordion.classList.remove('active')
    })

    this.active = e.target.getAttribute('data-toggle')

    this.setActiveTab()
    scroll.update()
  }

  handleAccordion(e) {
    if (e.target.parentNode.classList.contains('active')) {
      gsap.to(qs('[data-accordion-content]', e.target.parentNode), {
        duration: 1.2,
        height: 0,
        ease: Power4.easeOut,
        onComplete: () => {
          scroll.update()
        }
      })

      e.target.parentNode.classList.remove('active')
    } else {
      const activeTab = qs(`[data-tab="${this.active}"]`, this.container)
      const accordions = qsa('[data-accordion]', activeTab)

      accordions.forEach(accordion => {
        accordion.classList.remove('active')

        gsap.to(qs('[data-accordion-content]', accordion), {
          duration: 1.2,
          height: 0,
          ease: Power4.easeOut
        })
      })

      gsap.to(qs('[data-accordion-content]', e.target.parentNode), {
        duration: 1.2,
        height: 'auto',
        ease: Power4.easeOut,
        onComplete: () => {
          scroll.update()
        }
      })

      e.target.parentNode.classList.add('active')
    }
  }
}

export default new ArchiveFaq()
